/* eslint-disable import/no-anonymous-default-export */
import { Card, Stack } from '@mui/material';
import {
    BulkActionsToolbar,
    BulkDeleteButton,
    CreateButton,
    ListBase,
    ListToolbar,
    Pagination,
    SortButton,
    Title,
    TopToolbar,
    useGetIdentity,
    useListContext,
} from 'react-admin';

import { RoleEmpty } from './RoleEmpty';
import { RoleListContent } from './RoleListContent';
import { RoleListFilter } from './RoleListFilter';

export const RoleList = () => {
    const { identity } = useGetIdentity();

    if (!identity) return null;

    return (
        <ListBase
            disableAuthentication
            perPage={25}
            sort={{ field: 'id', order: 'ASC' }}
        >
            <RoleListLayout />
        </ListBase>
    );
};

const RoleListLayout = () => {
    const { data, isPending, filterValues } = useListContext();
    const { identity } = useGetIdentity();

    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    if (!identity || isPending) return null;

    if (!data?.length && !hasFilters) return <RoleEmpty />;

    return (
        <Stack direction={{ xs: 'column', md: 'row' }} sx={{ width: '100%' }}>
            <RoleListFilter />
            <Stack sx={{ width: '100%', minWidth: 0, flex: 1 }}>
                <Title title={'Roles'} />
                <ListToolbar actions={<RoleListActions />} />
                <BulkActionsToolbar>
                    <BulkDeleteButton />
                </BulkActionsToolbar>
                <Card>
                    <RoleListContent />
                </Card>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

const RoleListActions = () => (
    <TopToolbar>
        <SortButton fields={['id', 'name']} />
        <CreateButton
            variant="contained"
            label="New Role"
            sx={{ marginLeft: 2 }}
        />
    </TopToolbar>
);
